var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_20X20_photo_Back",
    "data-name": "20X20 photo Back",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4536",
    "data-name": "Rectangle 4536",
    width: 20,
    height: 20,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_111",
    "data-name": "Mask Group 111",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_224855104"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_224854888",
    d: "M5.4,7.511A1.669,1.669,0,0,0,3.729,9.178v8.805A1.668,1.668,0,0,0,5.4,19.649H14.6a1.668,1.668,0,0,0,1.666-1.666V9.178A1.668,1.668,0,0,0,14.6,7.511ZM14.6,20H5.4a2.02,2.02,0,0,1-2.018-2.017V9.178A2.02,2.02,0,0,1,5.4,7.16H14.6a2.02,2.02,0,0,1,2.017,2.017v8.805A2.02,2.02,0,0,1,14.6,20Z",
    fill: "#404040",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_224854648",
    d: "M14.036,7.511a.175.175,0,0,1-.176-.175V4.179a3.7,3.7,0,0,0-1.2-2.871A4,4,0,0,0,10,.351,3.685,3.685,0,0,0,6.14,4.179V7.336a.175.175,0,0,1-.351,0V4.179A4.037,4.037,0,0,1,7.11,1.045,4.348,4.348,0,0,1,10,0a4.348,4.348,0,0,1,2.89,1.045,4.037,4.037,0,0,1,1.321,3.134V7.336a.176.176,0,0,1-.176.175Z",
    fill: "#404040",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_224854840",
    d: "M10,11.429a1.131,1.131,0,1,0,1.131,1.131A1.132,1.132,0,0,0,10,11.429Zm0,2.613a1.482,1.482,0,1,1,1.482-1.482A1.484,1.484,0,0,1,10,14.042Z",
    fill: "#404040",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_224855056",
    d: "M10,16.082a.175.175,0,0,1-.176-.175V13.866a.175.175,0,0,1,.351,0v2.041a.176.176,0,0,1-.176.175Z",
    fill: "#404040",
    fillRule: "evenodd"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.338e7dad282e0cee998bf99796ca4c3b.svg";
export { ForwardRef as ReactComponent };